export default __webpack_public_path__ + "static/media/harish.bbc6430a.png";